exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-task-log-body[data-v-de0ed592]{white-space:pre-line}", ""]);

// exports
